/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import './ChristmasTreePermitsPromo.scss';

import { Button } from 'sarsaparilla';

import backgroundImageSrc from './images/tree-permits-background.webp';

export function ChristmasTreePermitsPromo() {
    return (
        <div className="nav--christmas-tree-permits-featured-promo">
            <div className="image-group">
                <img src={backgroundImageSrc} alt="" className="image" />
            </div>

            <div className="overlay" />
            <div className="overlay-shader" />

            <div className="content">
                <h2>Christmas Tree Permits</h2>
                <p>
                    Find and purchase permits to cut a Christmas tree from your favorite
                    National Forest, gather family and friends, and #BringHomeAStory this
                    holiday season!
                </p>

                <Button
                    className="learn-more-button"
                    appearance="tertiary-white"
                    aria-label="Learn more about Christmas tree permits"
                    href="/tree-permits"
                    gaReportName="Featured promo for christmas tree permits"
                    gaReportCreative="featured promo for christmas tree permits"
                    gaReportPosition="HomePage"
                    shouldReportToGA
                >
                    Learn More
                </Button>
            </div>
        </div>
    );
}
